module.exports = "/fonts/vendor/socicon/socicon.woff?944f06f5f65ef84a3a36e6c1c2d4b7ad";